<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4
      class="card-title"
      style="
        padding-top: 30px;
        padding-bottom: 30px;
        background-color: #c3c3c338;
      "
    >
      <b>Buy your Professional Snake Rescue Kit</b>
    </h4>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/OsDzU5ZHL3E"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>

        <div class="col-md-5">
          <br />
          <div class="card">
            <div
              class="card-body"
              style="text-align: center; background-color: #d66764"
            >
              <b style="color: white">ADVANCED KIT </b><br />
              Two hooks, Bagger Frame, two bags, Carry Case
              <br /><b>Rs.3300</b><br />
              ( including shipping & Taxes )
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <br />
          <div class="card">
            <div
              class="card-body"
              style="text-align: center; background-color: #d66764"
            >
              <b style="color: white">STANDARD KIT </b><br />
              Two hooks, two bags, Carry Case
              <br /><b>Rs. 2500</b> <br />( including shipping & Taxes )
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <br />

          <a href="/img/snakerescuekit.pdf" target="_blank">
            <img src="../assets/brochure.png" width="93%" height="auto"
          /></a>
        </div>
        <!-- <div class="col-md-12">
          <b>How to buy</b>
        </div> -->
        <div class="col-md-2"></div>
        <div class="col-md-8" style="padding-top:30px;">
          <img src="../assets/payment.png" width="50%" height="auto" /><br />
          <p>
            <b>8137939888@okbizaxis</b><br />
            Make the payment using UPI systems and what’s app the Txn id and
            share your address with PIN & Phone number
          </p>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-12">
          <br />
          <br />
          <p style="text-align: justify; font-size: 18px">
            This snake rescue kit is designed by experienced snake rescuers of
            Indiansnakes keeping in mind the field conditions and needs of snake
            rescuers across the country. Hundreds of snake rescuers across the
            country use these kits.
            <br />
            <br />
            <b>Large and small snake hooks</b> : The kit has a large snake hook
            ( 36” ) and a small snake hook ( 16”) which can be used to handle
            various sizes of snakes. Each hook is hand made using high-grade
            stainless steel and the handles are made of Chiselled teakwood.
            <br />
            <br />
            <b>Snake bagger frame</b> : The 36” long bagger is to be used with a
            cotton bag that can be used to safely bag a snake without touching
            the snake.
            <br />
            <br />
            <b>Cotton Bags</b> : One large and one small bag is provided as part
            of the kit which is made of think cotton cloth with double stitched
            edges and a safe corner to ensure handlers safety. The bags are good
            enough to restrain larger snakes up to 10 feet including python and
            king cobras.
            <br />
            <br />
            <b>Carry case</b> : The carry case can contain all the kit items
            together and can be carried as a sling bag by the rescuer while
            traveling. It also had additional pockets to keep additional items
            like crape bandage, small flashlight &
          </p>
        </div>

        <div class="col-md-12">
          <br />
          <div class="card" style="background-color: rgb(224, 192, 191)">
            <div class="card-body" style="tex-align: center">
              <i
                >Disclaimer : Indiansnakes does not sell the kits directly. It
                is manufactured and sold by a supplier as per our design. Usage
                of snake rescue kit for snake rescue is the sole responsibility
                of the person who buy/ use the kit. As snakes are protected
                wildlife, the user has to follow the provisions of the Wildlife
                (Protection), Act -1972 and we are not responsible for any legal
                / health matters, loss of life or property as a result of using
                the snake rescue kit.</i
              >
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <br />
          <br />
          <p>
            <b
              >The below video is one of the best demonstartion of safe snake
              rescue using hook,pipe and a snake bag</b
            >
          </p>
          <br />
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/scDGVAFVk4c"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./navbar";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    Navbar,
  },
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>